module.exports = __webpack_public_path__ + "static/media/alert-with-circle.d53b0947.svg";